<div class="page-layout-container">
    <h1 class="heading"> Batch Upload </h1>
    <div class="row mt-3">
        <div class="col-5">
            <file-upload [control]="fileUploadControl" class="upload"></file-upload>
        </div>
      <div class="col-5 margin-auto">
        <div class="row">
          <mat-label class="col-5 margin-auto">Document Name </mat-label>
          <div class="col-7 margin-auto">
            <div class="file-list" *ngIf="fileUploadControl.value.length > 0">
              <div class="file-item" *ngFor="let file of fileUploadControl.value"
                   (click)="fileUploadControl.removeFile(file)">
                {{ file.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-3">
            <mat-label class="col-5 margin-auto">Document Type </mat-label>
          <div class="col-7 margin-auto">
            <mat-form-field class="margin-auto">
              <select matNativeControl required [(ngModel)]="selectedOption">
                <option *ngFor="let document of documentsList" [value]="document.code">{{ document.name }}</option>
              </select>
            </mat-form-field>
          </div>
        </div>
      </div>
           <div class="col-2 margin-auto">
                 <button mat-button (click)="upload()" type="submit">Upload</button>
           </div>

        </div>
</div>
